// extracted by mini-css-extract-plugin
export default {"title":"Landing_title__TwW2Q","mainSlider":"Landing_mainSlider__siEsA"};